<template>
  <div class="user-detail-integral">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="">
      <el-table :data="userDetailIntegralInfo.integrals" border style="width: 100%">
        <el-table-column prop="integralId" :label="$t('userDetailIntegral.id')" align="center">
        </el-table-column>
        <el-table-column prop="integralName" :label="$t('userDetailIntegral.accountName')" align="center">
        </el-table-column>
        <el-table-column prop="objType" :label="$t('userDetailIntegral.objType')" align="center">
          <template slot-scope="scope">
            {{ scope.row.objType === '7007' ? $t('userDetailIntegral.merchant') : $t('userDetailIntegral.user') }}
          </template>
        </el-table-column>
        <el-table-column prop="objId" :label="$t('userDetailIntegral.userId')" align="center">
        </el-table-column>
        <el-table-column prop="link" :label="$t('userDetailIntegral.tel')" align="center">
        </el-table-column>
        <el-table-column prop="amount" :label="$t('userDetailIntegral.integralAmount')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getIntegralList } from '@/api/user/userDetailIntegralApi'

export default {
  name: 'UserDetailIntegral',
  data() {
    return {
      userDetailIntegralInfo: {
        integrals: [],
        link: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailIntegralInfo.link = data.tel
      this.loadIntegralData()
    },
    handleSwitch(data) {
      this.userDetailIntegralInfo.link = data.tel
      this.loadIntegralData()
    },
    loadIntegralData() {
      const params = {
        link: this.userDetailIntegralInfo.link,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getIntegralList(params).then(res => {
        this.userDetailIntegralInfo.integrals = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadIntegralData()
    }
  }
}
</script>

<style scoped>
.user-detail-integral {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>